/* Keep collection-card wishlist clicks in sync with the theme wishlist.
   The collection filter scripts can replace cards and intercept click events,
   so this handler runs during the capture phase. */
(function () {
  if (window.__sfCollectionWishlistInitialized) return;
  window.__sfCollectionWishlistInitialized = true;

  var storageKey = 'sf__wishlist-products';
  var buttonSelector = '.main-collection-product-grid .sf-wishlist__button';

  function getProducts() {
    try {
      var products = JSON.parse(localStorage.getItem(storageKey) || '[]');
      return Array.isArray(products) ? products : [];
    } catch (error) {
      return [];
    }
  }

  function saveProducts(products) {
    localStorage.setItem(storageKey, JSON.stringify(products));
    if (window.MinimogTheme && window.MinimogTheme.Wishlist) {
      window.MinimogTheme.Wishlist.products = products.slice();
    }
  }

  function setButtonState(button, active, updateText) {
    button.classList.toggle('added-to-wishlist', active);
    button.setAttribute('aria-pressed', active ? 'true' : 'false');

    var text = button.querySelector('.sf-wishlist__button-content');
    if (text && updateText) {
      var currentText = text.textContent;
      text.textContent = text.dataset.revertText || currentText;
      text.dataset.revertText = currentText;
    }
  }

  function updateCount(products) {
    document.querySelectorAll('.sf-wishlist-count').forEach(function (count) {
      count.textContent = products.length;
      count.style.display = products.length ? 'flex' : 'none';
    });
    document.body.classList.toggle('wishlist-has-item', products.length > 0);
  }

  function syncButtons(handle, active) {
    document.querySelectorAll('.sf-wishlist__button').forEach(function (button) {
      if (button.dataset.productHandle === handle) setButtonState(button, active, true);
    });
  }

  function syncInitialState() {
    var products = getProducts();
    document.querySelectorAll(buttonSelector).forEach(function (button) {
      setButtonState(button, products.indexOf(button.dataset.productHandle) !== -1, false);
    });
    updateCount(products);
  }

  document.addEventListener('click', function (event) {
    var button = event.target.closest(buttonSelector);
    if (!button) return;

    var handle = button.dataset.productHandle;
    if (!handle) return;

    event.preventDefault();
    event.stopPropagation();

    var products = getProducts();
    var productIndex = products.indexOf(handle);
    var active = productIndex === -1;

    if (active) {
      products.push(handle);
    } else {
      products.splice(productIndex, 1);
    }

    saveProducts(products);
    syncButtons(handle, active);
    updateCount(products);
  }, true);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', syncInitialState);
  } else {
    syncInitialState();
  }
})();
